import React from 'react';
import ReportingMarketingPage from '../components/ReportingMarketingPage';

const ReportingMarketingApp = (props) => (
  <ReportingMarketingPage {...props} />
);

export default ReportingMarketingApp;
